var FeaturedProductBuilderComponent = {
  name: '_FeaturedProduct_',
  inputs: [{
    name: 'desktopImage',
    type: 'file',
    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
    required: true
  }, {
    name: 'mobileImage',
    type: 'file',
    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
  }, {
    name: 'tooltips',
    type: 'list',
    copyOnAdd: false,
    subFields: [{
      name: 'xPositionPercentage',
      type: 'number',
      min: 1,
      max: 1000,
      defaultValue: 50
    }, {
      name: 'yPositionPercentage',
      type: 'number',
      min: 1,
      max: 1000,
      defaultValue: 50
    }, {
      name: 'tooltipText',
      type: 'string',
      defaultValue: 'Tooltip Text'
    }, {
      name: 'text',
      type: 'string'
    }]
  }, {
    name: 'tooltipsSmall',
    type: 'list',
    subFields: [{
      name: 'xPositionPercentage',
      type: 'number',
      min: 1,
      max: 1000,
      defaultValue: 50
    }, {
      name: 'yPositionPercentage',
      type: 'number',
      min: 1,
      max: 1000,
      defaultValue: 50
    }, {
      name: 'tooltipText',
      type: 'string',
      defaultValue: 'Tooltip Text'
    }, {
      name: 'text',
      type: 'string'
    }]
  }]
};
export default FeaturedProductBuilderComponent;